import { T, t } from './site/i18n';
import { NavAuth, SiteLogo } from './member/MemberUI';
import LangSwitcher from './site/LangSwitcher';
import { openPanel } from './member/store';
import React, { Component } from 'react'; //different
import './App.css';
import Footer from './footer';
import jwt_decode from "jwt-decode";
import Swal from 'sweetalert2'
import instance, { preoductionurl } from "./axios-instance";
import { NumericFormat } from 'react-number-format';
import Systems from "./SystemFunction";
import moment from 'moment';
class App extends Component {
    constructor(props) {
        super(props)
        this.state = {
            categorylist: [],
            rewardlist: [],
            activePage: 1,
            pagecount: 1,
            products_page_count: 1,
            isActive: false,
            menuOpen: false,
            activeTab: 1,
            formData: {}, // Contains login form data
            errors: {}, // Contains login field errors
            formSubmitted: false, // Indicates submit status of login form
            loading: true, // Indicates in progress state of login form
            userid: null,
            point: 0,
            balance: 0,
            loginstate: null,
            firstname: null,
            lastname: null,
            alert: null,
            modalOpen: false,
            handleClose: false,
            proderedeemlist: [],
            token: window.localStorage.getItem("token"),
            type: "",
            username: "",
            amount: "",
            remark: "",
            mainacc: "",
            rankpic: "1.jpeg",
            rankname: null,
            rankob: null,
            rankpoint: 0,
            name: "",
            password: "",
            linelink: null,
            left: false,
        }
    }
    toggleMenu = (e) => {
        if (e && e.preventDefault) e.preventDefault();
        this.setState((prev) => ({ menuOpen: !prev.menuOpen }));
    }
    closeMenu = () => {
        this.setState({ menuOpen: false });
    }
    logout = (e) => {

        // window.location.href = '/logout';

    }
    async componentDidMount() {
        await instance.post("/api/v1/mainsetting", {
            System: Systems,
        }).then((res) => {
            if (res.data.status === 200) {
                const datas = res.data.message;
                this.setState({
                    linelink: datas[1].value,
                });
            }
            else {
                // this.CheckThisGoalError();
            }
        });
        var userAgent = navigator.userAgent.toLowerCase()
        // if (userAgent.indexOf('safari') != -1) {
        //     if (userAgent.indexOf('chrome') > -1) {
        //     } else {
        //         await Swal.fire({
        //             title: 'Warning!',
        //             text: 'แนะนำให้ใช้งานบน Google Chorme เพื่อประสิทธิภาพที่ดีกว่า',
        //             icon: 'warning',
        //             confirmButtonText: 'သဘောတူသည်။'
        //         })
        //     }
        // }

        try {
            var token = localStorage.getItem('auth_token');
            //  //////console.log(token);
            if (token != null) {
                var decoded = jwt_decode(token);
                var Username = decoded.message.playerid;
                await this.rechecklogin(Username, token);
                this.setState({
                    userid: decoded.message.playerid,
                    username: decoded.message.playerid,
                    firstname: decoded.message.firstname,
                    lastname: decoded.message.lastname,
                    loginstate: true,
                });
            }
            else {
                this.setState({
                    loginstate: false,
                });
            }
        }
        catch (error) {
            //////console.log();
        }

    }
    login = (e) => {
        e.preventDefault();
        let errors = this.validateLoginForm();
    }
    onChange = event => {
        let nam;
        let val;
        if (event.target.name === undefined) {
            // //////console.log("undefined", event.target);
            nam = event.name;
            val = event.value;
        } else {
            // //////console.log("event", event.target);
            nam = event.target.name;
            val = event.target.value;
        }
        this.setState({ [nam]: val });

    };
    validateLoginForm = async (e) => {
        const { username, password } = this.state;
        //////console.log(username, password);
        if (username != "" && password != "") {
            instance.post("/api/v1/userlogin", {
                userid: username,
                password: password,
                System: Systems,
                Function: 'validateLoginForm-navbar.js'
            })
                .then((res) => {
                    console.log(username, password);
                    if (res.status === 200) {
                        console.log(res.data.status);
                        if (res.data.status === 200) {
                            localStorage.setItem('auth_token', res.data.token)
                            this.setState({
                                userid: res.data.message.member_id,
                                username: res.data.message.playerid,
                                firstname: res.data.message.firstname,
                                lastname: res.data.message.lastname,
                                point: res.data.message.Point,
                                balance: res.databalance,
                                loginstate: true,
                            });
                            window.location.href = '/'; // อยู่เว็บนี้ต่อ (ระบบสมาชิกในตัว)
                            // window.location.replace('https://play.Mta159.com?login=' + res.data.token);
                        }
                        else if (res.data.status === 401) {
                            Swal.fire({
                                title: t('common.error'),
                                text: t('common.invalid_credentials'),
                                icon: 'error',
                                confirmButtonText: t('common.ok')
                            })
                        }
                        else {
                            Swal.fire({
                                title: t('common.error'),
                                text: t('common.invalid_credentials'),
                                icon: 'error',
                                confirmButtonText: t('common.ok')
                            })
                            //   Bonn.alert("ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง")
                        }
                    }
                    else {
                        this.setState({
                            firstname: null,
                            lastname: null,
                            point: null,
                            loginstate: false,
                        });
                        var title = 'Error!'
                        var text = t('common.username_taken')
                        var object = { title, text }
                        this.CheckThisGoalError(object);
                    }
                });
        } else {
            Swal.fire({
                title: t('common.error'),
                text: t('common.missing_credentials'),
                icon: 'error',
                confirmButtonText: t('common.ok')
            })
        }
    }
    async componentDidMount() {
        try {
            await instance.post("/api/v1/mainsetting", {
                System: Systems,
            }).then((res) => {
                if (res.data.status === 200) {
                    const datas = res.data.message;
                    this.setState({
                        linelink: datas[1].value,
                        telegramlink: ((datas || []).find((m) => m && m.column === 'telegram') || {}).value || '',
                        System: res.data.tblcatagoryx[0].System
                    });
                }
            });
        }
        catch (error) {
            //////console.log();
        }
    }
    openAccout(evt, cityName) {
        var i, tabcontent, tablinks;
        tabcontent = document.getElementsByClassName("x-menu-account-list-sidebar");
        for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].className += " -open";
        }
    }

    cancelredeempromotion = async (e, index) => {
        e.preventDefault();
        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;
            Swal.fire({
                icon: 'warning',
                title: t('common.confirm_cancel_promo'),
                showCancelButton: true,
                confirmButtonText: t('common.confirm'),
            }).then(async (result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    await instance.post("/api/v1/usercancelpromotion", {
                        User_id: Username,
                        System: Systems,
                        no: index.no,
                    }, {
                        headers: { Authorization: `Bearer ${token}` }
                    }).then(async (res) => {
                        if (res.data.status === 200) {
                            this.checkpro(null, 999);
                            Swal.fire(t('common.done'), '', 'success')
                        }
                        else {
                            Swal.fire(t('common.try_later'), '', 'error')
                        }
                    });

                }
            })
        }

    }

    openAccoutcan(evt, cityName) {
        var i, tabcontent, tablinks;
        tabcontent = document.getElementsByClassName("x-menu-account-list-sidebar");
        for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].className = "x-menu-account-list-sidebar";
        }
    }

    async rechecklogin(Username, token) {

        try {
            // console.log(4);
            instance.post("/api/v1/checkpoint", {
                userid: Username,
                System: Systems,
                Function: 'rechecklogin-navbar.js'
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                //  console.log(res.data);
                if (res.data.status === 200) {
                    localStorage.setItem('auth_token', res.data.token)
                    this.setState({
                        rankpic: res.data.tblrank.image,
                        rankname: res.data.tblrank.name,
                        rankob: res.data.tblrank,
                        rankpoint: res.data.rankpoint,
                        accnumber: res.data.message.accnumber,
                        userid: res.data.message.member_id,
                        username: res.data.message.playerid,
                        fname: res.data.message.firstname,
                        point: res.data.message.Point,
                        balance: res.data.databalance,
                        loginstate: true,
                    });
                }
                else if (res.data.status === 401) {
                    localStorage.clear();
                    await Swal.fire({
                        title: t('common.warning'),
                        text: t('common.session_expired'),
                        icon: 'warning',
                        confirmButtonText: t('common.ok')
                    })
                    window.location.href = '/';
                }

            }).catch(async (err) => {
                console.log(err)
                if (err.response.status === 401 || err.response.status === 403) {
                    localStorage.clear();
                    await Swal.fire({
                        title: t('common.warning'),
                        text: t('common.session_expired'),
                        icon: 'warning',
                        confirmButtonText: t('common.ok')
                    })
                    window.location.href = '/';
                }
            });
        }
        catch (ex) {
            //////console.log(ex);
        }

    }
    checkpro = async (e, proid) => {
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        await instance.post("/api/v1/checkpromotion", {
            userid: Username,
            System: Systems,
            Proid: proid,
        }, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(async (res) => {
            if (res.data.status === 200) {
                //console.log(res.data)
                // console.log(res.data.message.tblpromotionredeems)
                if (res.data.type === 0) {
                    this.setState({
                        prodetail: res.data.message.tblpromotions,
                    });
                }
                else if (res.data.type === 1) {
                    this.setState({
                        proderedeemlist: res.data.message.tblpromotionredeems,
                    });

                }

            }
            else if (res.data.status === 201) {
                await Swal.fire({
                    title: t('common.error'),
                    text: t('common.promo_not_eligible'),
                    icon: 'error',
                    confirmButtonText: t('common.ok')
                })
                return false;
            }
            else if (res.data.status === 202) {
                await Swal.fire({
                    title: t('common.error'),
                    text: t('common.promo_active'),
                    icon: 'error',
                    confirmButtonText: t('common.ok')
                })
                return false;
            }

        }).catch(async (err) => {
            // console.log(err);
            if (err.response.status === 401 || err.response.status === 403) {
                localStorage.clear();
                await Swal.fire({
                    title: t('common.warning'),
                    text: t('common.session_expired'),
                    icon: 'warning',
                    confirmButtonText: t('common.ok')
                })
                window.location.href = '/';
            }
        });
    }


    validateLogout = (e) => {
        localStorage.removeItem('auth_token', '')
        this.setState({
            userid: null,
            username: null,
            password: null,
            firstname: null,
            lastname: null,
            point: null,
            loginstate: false,
        });
    }
    async recheccredit(evt) {

        evt.currentTarget.className += " fa-spin";
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        //  this.rechecklogin(Username, token);
        this.setState({
            userid: decoded.message.playerid,
            username: decoded.message.playerid,
            firstname: decoded.message.firstname,
            lastname: decoded.message.lastname,
            loginstate: true,
        });
        try {
            //  console.log(5);
            await instance.post("/api/v1/checkpoint", {
                userid: Username,
                System: Systems,
                Function: 'recheccredit-navbar.js'
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                //console.log(res.data);
                if (res.data.status === 200) {
                    localStorage.setItem('auth_token', res.data.token)
                    this.setState({
                        accnumber: res.data.message.accnumber,
                        userid: res.data.message.member_id,
                        username: res.data.message.playerid,
                        fname: res.data.message.firstname,
                        point: res.data.message.Point,
                        balance: res.data.databalance,
                        loginstate: true,
                    });
                    var i, tablinks;
                    tablinks = document.getElementsByClassName("-btn-balance");
                    for (i = 0; i < tablinks.length; i++) {
                        tablinks[i].className = tablinks[i].className.replace(" fa-spin", "");
                    }
                }
                else if (res.data.status === 401) {
                    localStorage.clear();
                    //   console.log(res.data);
                    await Swal.fire({
                        title: t('common.warning'),
                        text: t('common.session_expired'),
                        icon: 'warning',
                        confirmButtonText: t('common.ok')
                    })
                    window.location.href = '/';
                }

            }).catch(async (err) => {
                //    console.log(err);
                if (err.response.status === 401 || err.response.status === 403) {
                    localStorage.clear();
                    await Swal.fire({
                        title: t('common.warning'),
                        text: t('common.session_expired'),
                        icon: 'warning',
                        confirmButtonText: t('common.ok')
                    })
                    window.location.href = '/';
                }
            });
        }
        catch (ex) {
            //////console.log(ex);
        }
    }
    logout = (e) => {
        // e.preventDefault();
        let errors = this.validateLogout();
        if (errors === true) {
            // alert("You are successfully signed in...");
            window.location.reload()
        } else {

            this.setState({
                errors: errors,
                formSubmitted: true
            });
            window.location.reload()
        }
    }
    render() {

        const { loginstate, userid, username, point, firstname, lastname, balance, proderedeemlist } = this.state
        // //////console.log(this.state);
        return (
            <div >
                <button className={"wrapper-menu  sidebarCollapse" + (this.state.menuOpen ? " open" : "")} aria-label="Main Menu" onClick={this.toggleMenu}>
                    <svg width="40" height="40" viewBox="0 0 100 100">
                        <path className="line line1" d="M 20,29.000046 H 80.000231 C 80.000231,29.000046 94.498839,28.817352 94.532987,66.711331 94.543142,77.980673 90.966081,81.670246 85.259173,81.668997 79.552261,81.667751 75.000211,74.999942 75.000211,74.999942 L 25.000021,25.000058"></path>
                        <path className="line line2" d="M 20,50 H 80"></path>
                        <path className="line line3" d="M 20,70.999954 H 80.000231 C 80.000231,70.999954 94.498839,71.182648 94.532987,33.288669 94.543142,22.019327 90.966081,18.329754 85.259173,18.331003 79.552261,18.332249 75.000211,25.000058 75.000211,25.000058 L 25.000021,74.999942"></path>
                    </svg>
                </button>
                <div className="navbarmain">
                    <div className="logo">
                        <a
                            href="/"
                            className="custom-logo-link"
                            rel="home"
                        >
                            <SiteLogo
                                width={400}
                                height={110}
                                fallback="/build/web/ez-bet/img/logo-black.png?v=1"
                                className="custom-logo"
                                alt="BLUEWHITE"
                                decoding="async"
                            />
                        </a>{" "}
                    </div>
                    <div className={"menuicon " + (this.state.menuOpen ? "active" : "")} onClick={this.closeMenu}>
                        <div className="menu-menu-right-container">
                            <ul id="menu-menu-right" className="menu">
                                <li className="menu-item menu-item-type-custom menu-item-object-custom">
                                    <a href="/" className="menu-image-title-after menu-image-not-hovered">
                                        <img width={100} height={100} src="/local-assets/ideabet.fun/theme/betflix1688/wp-content/uploads/2022/05/5235.png" className="menu-image menu-image-title-after" alt="" decoding="async" />
                                        <span className="menu-image-title-after menu-image-title"><T k="nav.home" /></span>
                                    </a>
                                </li>
                                <li className="menu-item menu-item-type-custom menu-item-object-custom">
                                    <a role="button" className="menu-image-title-after menu-image-not-hovered"
                                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.closeMenu(); openPanel('promotion'); }}>
                                        <img width={100} height={100} src="/local-assets/ideabet.fun/theme/betflix1688/wp-content/uploads/2022/05/tab_promotion.png" className="menu-image menu-image-title-after" alt="" decoding="async" />
                                        <span className="menu-image-title-after menu-image-title"><T k="nav.promotion" /></span>
                                    </a>
                                </li>
                                <li className="menu-item menu-item-type-custom menu-item-object-custom">
                                    <a href={this.state.linelink} target="_blank" rel="noopener noreferrer" className="menu-image-title-after menu-image-not-hovered">
                                        <img width={100} height={100} src="/local-assets/ideabet.fun/theme/betflix1688/wp-content/uploads/2021/07/line.png" className="menu-image menu-image-title-after" alt="" decoding="async" />
                                        <span className="menu-image-title-after menu-image-title">Line</span>
                                    </a>
                                </li>
                                <li className="menu-item menu-item-type-custom menu-item-object-custom">
                                    <a href={this.state.telegramlink || this.state.linelink} target="_blank" rel="noopener noreferrer" className="menu-image-title-after menu-image-not-hovered">
                                        <img width={100} height={100} src="/build/web/igame-index-lobby-wm/img/1a6145d8-7259-41cd-99ad-01658666514d.png" className="menu-image menu-image-title-after" alt="" decoding="async" />
                                        <span className="menu-image-title-after menu-image-title">Telegram</span>
                                    </a>
                                </li>
                            </ul>
                        </div>{" "}
                        {this.state.menuOpen && (
                            <div className="menu-hamburger-lang" onClick={(e) => e.stopPropagation()}>
                                <LangSwitcher />
                            </div>
                        )}
                        <div className={"overlaymenu" + (this.state.menuOpen ? " active" : "")} onClick={this.closeMenu} />
                    </div>
                    {/* <div className="toploginbox">
                        <form>
                            <div className="el-input my-1">
                                <i className="fas fa-user" />
                                <input
                                    type="text"
                                    id="username"
                                    inputMode="text"
                                    onChange={this.onChange}
                                    name="username"
                                    pattern="[0-9]*"
                                    autoFocus=""
                                    className="inputstyle"
                                    placeholder="เบอร์โทรศัพท์"
                                />
                            </div>
                            <div className="el-input my-1">
                                <i className="fas fa-lock" />
                                <input
                                    type="password"
                                    id="password"
                                    name="password"
                                    onChange={this.onChange}
                                    className="inputstyle"
                                    placeholder="รหัสผ่าน"
                                />
                            </div>
                            <div className="flexcenter">
                                <button type="submit"
                                    onClick={(e) => {
                                        this.login(e)
                                    }} className="btn">
                                    <span>เข้าสู่ระบบ</span>
                                </button>
                            </div>
                        </form>
                    </div> */}
                    <div className="loginregishead">
                        <NavAuth />
                    </div>
                </div>


            </div>
        );
    }
}
export default App;
